<template>
  <el-dialog
    width="968px"
    custom-class="popAllocationContent"
    title="分配外部联系人"
    :visible.sync="dialogTableVisible"
    destroy-on-close
    :before-close="hidePop"
  >
    <!-- <i class="iconfont icon-guanbi" @click="hidePop"></i> -->
    <!-- 头部筛选 -->
    <el-form inline :model="form" class="filterContent">
      <div class="itemList">
        <el-form-item label="姓名:">
          <el-input v-model="form.name" :clearable="true" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="员工ID:">
          <el-input v-model="form.userid" :clearable="true" placeholder="请输入员工ID"></el-input>
        </el-form-item>
        <el-form-item label="部门:">
          <el-input
            v-model="form.department_name"
            :clearable="true"
            placeholder="请输入部门"
          ></el-input>
        </el-form-item>
        <el-form-item label="职务:">
          <el-input v-model="form.position" :clearable="true" placeholder="请输入职务"></el-input>
        </el-form-item>
        <el-form-item label="邮箱:">
          <el-input v-model="form.email" :clearable="true" placeholder="请输入邮箱"></el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="buttonList">
      <div class="leftContent">每次分配仅可选择一名负责人</div>
      <div class="rightContent">
        <el-button class="filterButton" type="primary" @click="onSearch">搜索</el-button>
      </div>
    </div>
    <div class="listContent">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        header-row-class-name="headerClass"
        :header-cell-style="headerObj"
        @selection-change="handleSelectionChange"
      >
        <template slot="empty">
          <!-- 没有数据 -->
          <NoData></NoData>
        </template>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="userid" label="员工ID"></el-table-column>
        <el-table-column prop="department_name" label="部门"></el-table-column>
        <el-table-column prop="position" label="职位"></el-table-column>
        <el-table-column prop="email" label="邮箱"></el-table-column>
      </el-table>
      <el-pagination
        v-if="tableData.length > 0"
        class="pagination"
        style="background-color: #ffffff"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="g_pageSizesConfig"
        :total="total"
        :page-size="limit"
        :current-page="page"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      ></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="hidePop">取 消</el-button>
      <el-button type="primary" :disabled="!selectedRow" @click="onSubmit">确 定</el-button>
    </span>
    <!-- <div class="bottomButtonList">
      <el-button class="buttonItem cancel" @click="hidePop">取消</el-button>
      <el-button class="buttonItem" type="primary" :disabled="!selectedRow" @click="onSubmit">
        保存
      </el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { getPrincipalInfoListApi } from '@/api/enterpriseWeChatManagement';
import NoData from '@/components/no-data';
export default {
  name: 'PopAllocation',
  components: {
    NoData,
  },
  props: {
    dialogTableVisible: {
      type: Boolean,
      default: false,
    },
    customers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headerObj: {
        background: '#f5f7fa',
      },
      form: {
        name: '',
        userid: '',
        department_name: '',
        position: '',
        email: '',
      },
      tableData: [],
      selectedRow: null,
      page: 1 /* 当前页面数 */,
      limit: this.g_pageSizeDefault /* 当前页面显示数目 */,
      total: 0 /* 总数 */,
      loading: false,
    };
  },
  watch: {
    // dialogTableVisible(val) {
    //   if (val) {
    //     this.getPrincipalList();
    //   }
    //   if (!val) {
    //     this.form = {
    //       name: '',
    //       department_name: '',
    //       position: '',
    //       email: '',
    //     };
    //     this.tableData = [];
    //     this.page = 1;
    //   }
    // },
  },
  created() {
    this.getPrincipalList();
  },
  mounted() {},
  methods: {
    /* 负责人列表 */
    async getPrincipalList() {
      this.loading = true;
      const params = {
        ...this.form,
        page: this.page,
        limit: this.limit || this.g_pageSizeDefault,
      };
      try {
        const res = await getPrincipalInfoListApi(params);
        this.tableData = res.list;
        this.total = res.total;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
      }
      this.loading = false;
    },
    /* 搜索 */
    onSearch() {
      this.page = 1;
      this.getPrincipalList();
    },
    /* 表格多选 */
    handleSelectionChange(val) {
      if (val.length) {
        val.forEach((item, index) => {
          if (index === val.length - 1) {
            this.$refs.multipleTable.toggleRowSelection(item, true);
            this.selectedRow = item;
          } else {
            this.$refs.multipleTable.toggleRowSelection(item, false);
          }
        });
      } else {
        this.selectedRow = null;
      }
    },
    /* 切换分页 */
    handleCurrentChange(val) {
      this.page = val;
      this.getPrincipalList();
    },
    handleSizeChange(size) {
      this.limit = size;
      this.getPrincipalList();
    },
    hidePop() {
      this.$emit('hidePop');
    },
    async onSubmit() {
      const oldUserid = this.customers.map((item) => item.principal_userid);
      if (oldUserid.includes(this.selectedRow.userid)) {
        this.$message.warning(`分配前和分配后的负责人都包含${this.selectedRow.name},请重新选择`);
        return;
      }
      const params = {
        takeover_userid: this.selectedRow.userid,
        takeover_username: this.selectedRow.name,
        customers: this.customers.map((item) => {
          const items = { ...item };
          items.customer_name = item.custom_name;
          items.handover_userid = item.principal_userid;
          items.handover_name = item.principal_name;
          return items;
        }),
      };

      this.$emit('onSubmit', params);

      // const res = await this.$goRequestData(
      //   "/EyaoSaaSTransferOnjobCustomer",
      //   params
      // );
      // console.log("提交", res);
      // if (res) {
      //   this.$emit("hidePop");
      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.popAllocationContent {
  // .filterContent {
  //   display: flex;
  //   align-items: flex-end;
  //   flex-direction: column;
  //   .itemList {
  //     width: 100%;
  //     display: flex;
  //     justify-content: space-between;
  //     margin-top: 30px;
  //     ::v-deep.el-form-item {
  //       margin-bottom: 0;
  //       .el-input {
  //         width: 144px;
  //         .el-input__inner {
  //           width: 100%;
  //         }
  //       }
  //     }
  //   }
  // }
  .buttonList {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding: 16px 0;
    .leftContent {
      font-size: 16px;
      color: #313233;
    }
    // .rightContent {
    //   ::v-deep.filterButton {
    //     width: 128px;
    //     height: 48px;
    //     font-size: 16px;
    //     margin-left: 16px;
    //     text-align: center;
    //     padding: 0;
    //   }
    // }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
  }
  .listContent {
    ::v-deep.el-table {
      .headerClass {
        .el-checkbox__input {
          display: none;
        }
      }
    }
    .pagination {
      text-align: right;
      margin: 10px 0;
    }
  }
}
</style>
